<template>
  <div class="notPage" id="page">
    <popup class="login middle center rtl">
      <h1>התחבר למערכת</h1>
      <input type="text" name="login" v-model="login" placeholder="Email" class="ltr" />
      <input type="password" name="password" v-model="password" placeholder="Password" class="ltr" />
      <span class="center errorMessage colorDanger" v-if="false">שגיאה, אימייל ו/או סיסמא לא נכונים</span>
      <button v-on:click.prevent="signin()">התחבר</button>
    </popup>
  </div>
</template>
<script>
import { auth } from "@/main";

export default {
  data() {
    return {
      auth: auth,
      login: null,
      password: null
    };
  },
  methods: {
    signin() {
      auth.signin(this.login, this.password);
    }
  }
};
</script>



// WEBPACK FOOTER //
// Login.vue?0c0170c2